import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ProductShowcase.css';

const ProductShowcase = () => {
  const { t } = useTranslation();
  const ctaText = t('kit.ctaText');
  const btnOrder = t('kit.cta');
  const btnHow = t('kit.how');

  return (
    <section className="product-showcase">
      <div className="container">
        <div className="product-content">
          <div className="product-image" data-aos="fade-right">
            <picture>
              <source type="image/webp" srcSet="/images/ban_04.webp" />
              <img 
                src="/images/ban_04.png" 
                alt={t('kit.imgAlt')} 
              />
            </picture>
          </div>
          <div className="product-text" data-aos="fade-left">
            <p className="product-description">
              {ctaText}
            </p>
            <div className="product-actions">
              <button className="btn btn-purple">{btnOrder}</button>
              <Link to="/kit-lumina" className="btn btn-secondary">{btnHow}</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;


